import React from 'react'
import { XMarkIcon } from '@heroicons/react/20/solid'
import './add-note.css'
import { InputWithInsetLabel } from '../../DanitComponents/Inputs/InputWithInsetLabel'

const AddNote = (props) => {
    return(
        <div className="add-note-wrapper">
            <div className="add-note-popup-box">
                <div className='add-note-x-wrapper'>
                    <XMarkIcon color='#2A3944' width={'30px'} onClick={() => props.setNotesOpen(false)} />
                </div>
                <h4>Anything we should know about this month?</h4>
                <textarea className="add-note-text-box" placeholder="Type your notes here..." value={props.note} onChange={(e) => props.setNote(e.target.value)} />
                <div className="add-note-save-and-close" style={props.note === '' ? {backgroundColor: '#D6DBE0', color: '#637381'} : {backgroundColor: '#fff', border: '1px solid #57AEFF', color: '#57AEFF'}} onClick={() => props.setNotesOpen(false)}>Save Note</div>
            </div>
        </div>
    )
}
export default AddNote